(function () {
  'use strict';

  // TODO: WIlly - pending refactoring

  angular.module('app').component('bookingItemStatusLabel', bookingItemStatusLabel());

  function bookingItemStatusLabel() {
    return {
      bindings: {
        status: '<',
        width: '@',
        icon: '<',
      },
      controller: BookingItemStatusLabelComponent,
      controllerAs: 'vm',
      template:
        '<span class="label label-{{ vm.statusClass }} {{ vm.width }}">' +
        '<i class="fa fa-{{ vm.statusIcon }}" uib-tooltip="{{ vm.statusTitle }}" ng-if="vm.icon"></i>' +
        '<span ng-if="!vm.icon">{{ vm.statusTitle }}</span>' +
        '</span>',
    };
  }

  BookingItemStatusLabelComponent.$inject = ['$translate'];

  function BookingItemStatusLabelComponent($translate) {
    const vm = this;

    vm.$onChanges = function () {
      setStatusLabel();
    };

    function setStatusLabel() {
      let statusClass;
      let statusIcon;
      let statusTitle;

      // oncart, draft, pending, requested, confirmed, declined, cancelled
      switch (vm.status) {
        case 'oncart':
          statusClass = 'warning';
          statusIcon = 'shopping-cart';
          statusTitle = 'ONCART';
          break;
        case 'draft':
          statusClass = 'default';
          statusIcon = 'eraser';
          statusTitle = 'DRAFT';
          break;
        case 'pending':
          statusClass = 'primary';
          statusIcon = 'spinner';
          statusTitle = 'PENDING';
          break;
        case 'requested':
          statusClass = 'default';
          statusIcon = 'envelope';
          statusTitle = 'REQUEST_SENT';
          break;
        case 'confirmed':
          statusClass = 'success';
          statusIcon = 'check';
          statusTitle = 'CONFIRMED';
          break;
        case 'declined':
          statusClass = 'warning';
          statusIcon = 'minus';
          statusTitle = 'DECLINED';
          break;
        case 'cancelled':
          statusClass = 'danger';
          statusIcon = 'times';
          statusTitle = 'CANCELLED';
          break;
      }

      vm.statusClass = statusClass;
      vm.statusIcon = statusIcon;
      vm.statusTitle = $translate.instant(statusTitle);
    }
  }
})();
